import { LocalizedText } from "@/i18n/LocalizedText";
import { useEffect, useState } from "react";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "./ui/dialog";
import { Button } from "./ui/button";
import type { Brand } from "./AppSidebar";
import { Label } from "./ui/label";
import { Input } from "./ui/input";

const AddCompetitorDialog = ({
  addMutation,
  openAddPromptDialog,
  setOpenAddPromptDialog,
}: {
  currentBrand: Brand;
  addMutation: any;
  openAddPromptDialog: boolean;
  setOpenAddPromptDialog: (val: boolean) => void;
}) => {
  const [competitor, setCompetitor] = useState("");
  const [competitorUrl, setCompetitorUrl] = useState("");
  const [addCompetitorError, setAddCompetitorError] = useState("");

  const handleCompetitorAdd = async () => {
    if (!competitor.length || !competitorUrl.length) {
      return setAddCompetitorError("Competitor name and url are required");
    }

    const newCompetitor = {
      text: competitor,
      url: competitorUrl,
    };

    addMutation(newCompetitor);

    setOpenAddPromptDialog(false);
    setCompetitor("");
    setCompetitorUrl("");
  };

  useEffect(() => {
    setAddCompetitorError("");
  }, [openAddPromptDialog]);

  return (
    <Dialog open={openAddPromptDialog} onOpenChange={setOpenAddPromptDialog}>
      <DialogTrigger asChild>
        <Button
          variant="outline"
          className="hover:bg-[#ff8138] hover:text-white text-white cursor-pointer bg-[#FF5E00]"
          onClick={() => setOpenAddPromptDialog(true)}
        >
          <LocalizedText id="legacy.add.competitor.dmnwsk" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            <LocalizedText id="legacy.add.competitor.dmnwsk" />
          </DialogTitle>
        </DialogHeader>
        <div className="grid gap-4">
          <div className="flex gap-2 flex-col">
            <Label
              className="mb-1 text-md font-normal text-gray-700"
              htmlFor="name"
            >
              <LocalizedText id="legacy.name.yjpg1u" />
            </Label>
            <Input
              id="name"
              type="text"
              autoComplete="off"
              value={competitor}
              onChange={(e) => setCompetitor(e.target.value)}
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-slate-300"
            />
          </div>

          <div className="flex gap-2 flex-col">
            <Label
              className="mb-1 text-md font-normal text-gray-700"
              htmlFor="website"
            >
              <LocalizedText id="legacy.website.10ekgqm" />
            </Label>
            <Input
              id="website"
              type="text"
              autoComplete="off"
              value={competitorUrl}
              onChange={(e) => setCompetitorUrl(e.target.value)}
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-slate-300"
            />
          </div>

          {addCompetitorError && (
            <p className="text-red-500 text-sm">{addCompetitorError}</p>
          )}
        </div>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline" className="cursor-pointer">
              <LocalizedText id="legacy.cancel.18x3nqb" />
            </Button>
          </DialogClose>
          <Button
            type="submit"
            onClick={handleCompetitorAdd}
            className="cursor-pointer hover:bg-[#ff8138] text-white cursor-pointer bg-[#FF5E00]"
          >
            <LocalizedText id="legacy.add.competitor.1tsloys" />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AddCompetitorDialog;
